import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
const CACHE = "innova.user";

const cached = () => {
  try { return JSON.parse(localStorage.getItem(CACHE) || "null"); } catch { return null; }
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem(CACHE, JSON.stringify(r.data)); })
      .catch((e) => {
        // hors réseau (zone rurale): on garde la session en cache pour l'app chauffeur
        if (!e.response && cached()) setUser(cached());
        else { setUser(false); localStorage.removeItem(CACHE); }
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    localStorage.setItem(CACHE, JSON.stringify(data));
    return data;
  };

  const loginPin = async (pin) => {
    const { data } = await api.post("/auth/pin-login", { pin });
    setUser(data);
    localStorage.setItem(CACHE, JSON.stringify(data));
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
    localStorage.removeItem(CACHE);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, loginPin, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
